import { render, staticRenderFns } from "./CaseIssueRelation.vue?vue&type=template&id=c4becb48&scoped=true"
import script from "./CaseIssueRelation.vue?vue&type=script&lang=js"
export * from "./CaseIssueRelation.vue?vue&type=script&lang=js"
import style0 from "./CaseIssueRelation.vue?vue&type=style&index=0&id=c4becb48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4becb48",
  null
  
)

export default component.exports